export enum Endpoints {
  DashboardPage = "dashboard__get_for_business_admin",
  DashboardPageGestion = "dashboard__get_for_business_admin_gestion",
  DashboardPageBienestar = "dashboard__get_for_business_admin_bienestar",
  DashboardIpayResumen = "dashboard__get_for_ipay_admin_resumen",
  DashboardIpayColocaciones = "dashboard__get_for_ipay_admin_colocaciones",
  DashboardIpayCartera = "dashboard__get_for_ipay_admin_cartera",
  DashboardIpayRecaudacion = "dashboard__get_for_ipay_admin_recaudacion",
  DashboardIpayIngresos = "dashboard__get_for_ipay_admin_ingresos",
  DashboardIpayTesoreria = "dashboard__get_for_ipay_admin_tesoreria",
  DashboardIpayOperacion = "dashboard__get_for_ipay_admin_operacion",
  DashboardIpayAlertas = "dashboard__get_for_ipay_admin_alertas",
  DashboardIpayFilters = "dashboard__get_ipay_admin_filters",


  UserGetMenu = "user__get_menu",
  UserGetSubMenuMetadata = "user__get_submenu_metadata",

  // OPCIONES DEL SISTEMA (SEGURIDAD)
  SystemOptionList = "system_option__list",
  SystemOptionUpsert = "system_option__upsert",
  SystemOptionUpdateStatus = "system_option__update_status",
  SystemOptionReorder = "system_option__reorder",

  // ROLES (SEGURIDAD)
  SecurityRoleList = "security_role__list",
  SecurityRoleGet = "security_role__get",
  SecurityRoleAvailableOptions = "security_role__available_options",
  SecurityRoleUpsert = "security_role__upsert",
  SecurityRoleUpdateStatus = "security_role__update_status",
  UserSecurityRoleList = "user_security_role__list",
  UserSecurityRoleSet = "user_security_role__set",

  // COLLABORATOR
  CollaboratorById = "user__get_by_id",
  ListUser = "user__list",
  UpdateStatusUser = "user__update_status",

  // BUSINESS
  ListBussinesPage = "business__list",
  ListBussinesById = "business__get_by_id",
  SaveBussines = "business__upsert",
  UpdateStatusBussines = "business__update_status",
  CheckDuplicateBussines = "business__check_duplicates",
  GetBusinessFinancialReportConfig = "business_financial_report_config__get",
  SaveBusinessFinancialReportConfig = "business_financial_report_config__upsert",
  BusinessGetPeriods = "business__get_periods",
  BusinessGetPeriodsPayrollCutDay = "business__get_periods_payroll_cut_day",

  ListGroupBussinesPage = "business_group__list",
  ListGroupBussinesById = "business_group__get_detail",
  ListBusinessByGroup = "business_group__get_businesses",
  SaveGroupBussines = "business_group__upsert",
  UpdateStatusGroupBussines = "business_group__toggle_enable",


  ListSuscriptionPriceList = "service_cost__list",
  ListSuscriptionPriceById = "service_cost__get_by_id",
  SaveSuscriptionPrice = "service_cost__upsert",
  UpdateStatusSuscriptionPrice = "business_suscription_price__update_status",

  //ADELANTO SUELDO
  AdelantoSueldoListPage = "lending_request__list",
  SolicitudProductoById = "lending_request__get_detail",
  LendingRequestUpdateStatus = "lending_request__update_status",
  LendingUpdateDisbursement = "lending__update_disbursement",
  LendingFileDelete = "lending__file__delete",


  // DESEMBOLSOS
  DisbursementsListPage = "lending_disbursement__list",

  // PRODUCTS
  ProductsListPage = "lending__list",
  ProductsScheduleExcel = "lending__list_schedule_for_excel_export",
  LendingDetailById = "lending__get_detail",
  LendingFilesByIdLending = "lending__list_files",
  LendingFilesUpSert = "lending__file__add",
  LendingListQuotas = "lending__list_quotas",
  LendingUpdateQuotasPayment = "quota__update_payment",
  InactivationUpdateQuotasPayment = "inactivation__quota_update_payment",
  LendingUpdateDatePaymentExpected = "lending__update_date_payment_expected",
  LendingDirectQuotasPayment = "lending__direct_quotas_payment",


  //AMORTIZATION
  AmortizationListPage = "lending_liquidation__list",
  AmortizationDetailById = "lending_liquidation__get_detail",
  AmortizationUpdateStatus = "lending_liquidation__update_status",
  AmortizationLiquidarLending = "lending_liquidation__generate_quota",
  GetAmountLiquidationLending = "lending_liquidation__calculate_amount",
  AmortizationMarkFileViewed = "lending_file__mark_viewed",
  AmortizationSavePayment = "lending_liquidation__save_payment",


  //PROMOCIONES
  PromotionListPage = "promotion__list",
  PromotionDetailById = "promotion__get_by_id",
  PromotionUpsert = "promotion__upsert",
  PromotionToggleEnable = "promotion__toggle_enable",


  //COMERCIOS
  ComerceListPage = "commerce__list",
  ComerceDetailById = "commerce__get_by_id",
  ComerceUpsert = "commerce__upsert",
  ComerceToggleEnable = "commerce__toggle_enable",


  //LIQUIDACIONES
  LiquidacionesListPage = "lending_liquidation__list_summary",
  BusinessLendingLiquidationsList = "business_lending_liquidation_list_v2",
  LiquidationsListAdmin = "lending_liquidation__list",
  LiquidationsListDataExcel = "lending_liquidation__get_data_excel",
  LiquidationsMarkDownloaded = "mark_liquidations_downloaded",


  // TRANSACCIONES 
  TransactionsList = "lending__list_transactions",
  LendingListTransactionsMarkDownload = "lending_list_transactions__mark_download",
  PaymentManagementListPage = "quota__list",
  QuotaListPageByBusiness = "quota__list_by_business_v2",


  // CURSOS
  CourseListPage = "course__list",
  CourseDetailById = "course__get_detail",
  CourseUpSert = "course__upsert",
  CourseDelete = "course__delete",
  CourseChangeStatus = "course__disable",
  CourseCategoriesList = "course_category__list",

  LessonListByModule = "lesson__list",

  ModulesByCourseId = "module__list",
  ModuleUpSert = "module__upsert",
  ModuleDisabledById = "module__disable",

  LessonUpSert = "lesson__upsert",
  LessonDetailById = "lesson__get_detail",
  LessonDisabledById = "lesson__disable",

  EvaluationUpSert = "evaluation__upsert",
  EvaluationById = "evaluation__get_detail",
  EvaluationDisabledById = "evaluation__disable",


  //BAJA DE COLABORADOR
  BajaColaboradorListPage = "user_inactivation_request__list",
  BajaColaboradorDetailById = "user_inactivation_request__get_detail",
  BajaColaboradorUpdateStatus = "user_inactivation_request__update_status",


  //FACTURACION
  FacturationListPage = "invoice__list",
  FacturationDetailById = "invoice__get_detail",
  FacturationUpsert = "commerce__upsert",
  FacturationToggleEnable = "commerce__toggle_enable",


  //SORTEOS
  RafflesListPage = "raffle__list",
  RafflesDetailById = "raffle__get_by_id",
  RafflesUpsert = "raffle__upsert",
  RafflesToggleEnable = "raffle__toggle_enable",
  GetKpisFundIpay = "admin__fund__get_kpis",
  GetMovementsFundIpay = "admin__fund__get_movements",
  GetBusinessesActiveRaffles = "raffle__get_active_businesses",

  GetKpisTransactions = "admin__transactions__get_kpis",
  GetListTransactions = "admin__transactions__get_list",
  GetDetailTransactionById = "admin__transactions__get_detail",

  //GANADORES
  WinnersListPage = "winner__list",
  WinnerGetDetailById = "winner__get_detail",
  WinnerUpSert = "winner__upsert",

  //CONFIGURACION GLOBAL
  ConfigHistoryList = "admin__config_history__list",
  UserHistoryList = "admin__user_history__list",
  BusinessHistoryList = "admin__business_history__list",
  EmploymentPeriodList = "admin__user_employment_period__list",
  EmploymentPeriodUpdate = "admin__user_employment_period__update",
  ConfigGlobalList = "admin__config_global__list",
  ConfigGlobalUpSert = "admin__config_global__upsert",

  //CONFIGURACION GENERAL (app_config: IGV, salario mínimo, flags WhatsApp/Nubefact)
  ConfigGeneralGet = "admin__config_general__get",
  ConfigGeneralUpsert = "admin__config_general__upsert",
  ConfigGeneralUnlock = "admin__config_general__unlock",
  ConfigGeneralLock = "admin__config_general__lock",

  ConfigBusinessList = "admin__config_business__list",
  ConfigBusinessUpSert = "admin__config_business__upsert",
  ConfigBusinessApplyGlobalConfig = "admin__config_business__apply_global_multiple",
  ConfigBusinessGetDetail = "admin__config_business__get_detail",


  // NOTIFICATIONS TEMPLATE

  NotificationTemplateListPage = "notification_template__list",
  NotificationTemplateById = "notification_template__get_by_id",
  NotificationTemplateUpsert = "notification_template__upsert",
  NotificationTemplateToggleEnable = "notification_template__toggle_enable",

  // RECAUDACION
  RecaudationList = "recaudation__list",
  RecaudationKpis = "recaudation__kpis",


  UserGetProfile = "user__get_profile_new",

  BankListPage = "bank__list",
  BankUpSert = "bank__upsert",
  BankUpdateStatus = "bank__update_status",

  BanksAccountsListPage = "bank_configuration__list",
  BanksAccountsUpSert = "bank_configuration__upsert",
  BankAccountUpdateStatus = "bank_account__update_status",

  // CATÁLOGOS (MANTENIMIENTOS)
  CatalogList = "catalog__list",
  CatalogGetUsage = "catalog__get_usage",
  CatalogUpsert = "catalog__upsert",
  CatalogUpdateStatus = "catalog__update_status",

  // MONEDAS (MANTENIMIENTOS)
  CurrencyListPage = "currency__list",
  CurrencyUpdateStatus = "currency__update_status",
  CurrencyUpSert = "currency__upsert",

  // PAISES (MANTENIMIENTOS)
  CountryListPage = "country__list",
  CountryUpSert = "country__upsert",
  CountryUpdateStatus = "country__update_status",

  // TIPOS DOCUMENTOS (MANTENIMIENTOS)
  CardTypeListPage = "id_card_type__list",
  CardTypeUpSert = "id_card_type__upsert",
  CardTypeUpdateStatus = "id_card_type__update_status",

  // CATEGORIAS EMPRESAS (MANTENIMIENTOS)
  BusinessCategoryListPage = "business_category__list",
  BusinessCategoryUpSert = "business_category__upsert",
  BusinessCategoryUpdateStatus = "business_category__update_status",

  // SOFTWARE PLANILLA (MANTENIMIENTOS)
  PayrollSoftwareListPage = "payroll_software__list",
  PayrollSoftwareUpSert = "payroll_software__upsert",
  PayrollSoftwareUpdateStatus = "payroll_software__update_status",

  // INTEGRACIÓN DE PLANILLAS (MANTENIMIENTOS)
  PayrollIntegrationClientListPage = "payroll_integration_client__list",
  PayrollIntegrationClientCreate = "payroll_integration_client__create",
  PayrollIntegrationClientUpdateStatus = "payroll_integration_client__update_status",
  PayrollIntegrationRequestLogListPage = "payroll_integration_request_log__list",
  PayrollIntegrationRequestLogDetail = "payroll_integration_request_log__get_detail",

  // ESTADOS COLABORADOR (MANTENIMIENTOS)
  EmployeeReasonListPage = "employee_reason__list",
  EmployeeReasonUpSert = "employee_reason__upsert",
  EmployeeReasonUpdateStatus = "employee_reason__update_status",

  // STATE (MANTENIMIENTOS)
  StateListPage = "state__list",
  StateUpSert = "state__upsert",
  StateUpdateStatus = "state__update_status",

  // PROVINCE (MANTENIMIENTOS)
  ProvinceListPage = "province__list",
  ProvinceUpSert = "province__upsert",
  ProvinceUpdateStatus = "province__update_status",

  // DISTRICT (MANTENIMIENTOS)
  DistrictListPage = "district__list",
  DistrictUpSert = "district__upsert",
  DistrictUpdateStatus = "district__update_status",

  // CATEGORIAS DE COMERCIOS (MANTENIMIENTOS)
  CommerceCategoryListPage = "commerce_category__list_page",
  CommerceCategoryUpSert = "commerce_category__upsert",
  CommerceCategoryUpdateStatus = "commerce_category__update_status",
  
  // CATEGORIAS DE CURSOS (MANTENIMIENTOS)
  CourseCategoryListPage = "course_category__list_page",
  CourseCategoryUpSert = "course_category__upsert",
  CourseCategoryUpdateStatus = "course_category__update_status",
  
  // // (MANTENIMIENTOS)
  // ListPage = "__list",
  // UpSert = "__upsert",
  // UpdateStatus = "__update_status",
}


export enum eFuntions {
  GenerateContract = "generate-contract",
  GenerateNoDebtLetter = "generate-no-debt-letter",
  GenerateInvoice = "generate-invoice",
  GenerateTopicAudio = "generate-topic-audio",

  BulkDeactivateUsers = "bulk-deactivate-users",
  BulkSuspendUsers = "bulk-suspend-users",
  BulkQuotaPayment = "bulk-quota-payment",

  TransactionsExportExcel = "export-transactions-excel",

  SendWelcomeEmail = "send-welcome-email",
  SendEmailLendingRequest = "send-email-lending-request",
  SendFinancialReport = "send-financial-report",
}